export function getMemoryUsage() {
    // @ts-ignore
    const { memory } = window.performance;
    return {
        used: memory.usedJSHeapSize,
        percentUsed: memory.usedJSHeapSize / memory.jsHeapSizeLimit,
        total: memory.totalJSHeapSize,
        limit: memory.jsHeapSizeLimit,
    };
}
export function getSomething() { }
